import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import './styles/toastify/react.toastify.styl'
import { store } from './redux/configureStore'
import LoginPage from './modules/login'
import LogoutIDN from './modules/logout.idn'
import { Security, SecureRoute } from './modules/oauth'

import './app.styl'
import './app.css'

// import font css here to ensure that
// the webpack build pipeline picks up the font css
import './fonts/material-icons/material-icons.css'
import './fonts/leaplabs/leaplabs-icons.css'
import './fonts/roboto/roboto.css'
import './fonts/text-security/text-security.css'
import { Routes } from './constants/routes'
import AuthorizeIDN from './modules/oauth/components/authorize.idn'
import Shell from './modules/shell'

interface Props {}

const App: React.FC<Props> = () => (
  <Provider store={store}>
    <ToastContainer autoClose={false} />
    <Router>
      <Security>
        <Route path={Routes.loginPage} component={LoginPage} />
        <Route exact path="/authorize/idn" component={AuthorizeIDN} />
        <SecureRoute exact path="/logout" component={LogoutIDN} />
        <SecureRoute path="/" component={Shell} />
      </Security>
    </Router>
  </Provider>
)

export default App
